// api/setupAxios.js
import axios from 'axios';

// set defaults & interceptor
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL_API;

axios.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'x-api-key': process.env.REACT_APP_X_API_KEY
    };
    console.log('Interceptor running, headers:', config.headers);
    return config;
  },
  (error) => Promise.reject(error)
);
